module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.label) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu-list",
    class: _vm.type
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-039b4f52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Menus.vue
// module id = 326
// module chunks = 0